import React, { useState, useRef } from "react";
//import Link from "next/link";
import Page from "../components/Page";
import fetch from "isomorphic-unfetch";
import ContentBox from "../components/ContentBox";
import { Box, Heading, Text, Link } from "rebass/styled-components";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { scroller } from "react-scroll";
import Reaptcha from "reaptcha";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _t from "../hooks/useTranslation";
import { faCheck, faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { apiEndpoint } from "../prismic-configuration";
import Prismic from "@prismicio/client";
import { Label, Input, Textarea } from "../components/Forms";
import { logEvent } from "../utils/analytics";
import { RichText } from "prismic-reactjs";

const Contact = ({ pageContent, lang = "nl", doc }) => {
  const { data } = doc;

  const createMarkup = (content) => {
    return { __html: content };
  };

  const [state, setState] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    street: "",
    city: "",
    message: "",
    GDPR: null,
  });

  const [recaptchaToken, setRecaptchaToken] = useState("");

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [messages, setMessages] = useState({});
  const [formSuccess, setFormSuccess] = useState(false);
  const [formFailed, setFormFailed] = useState(false);
  const [fieldValdation, setFieldValidation] = useState(false);

  const captcha = useRef(null);

  const handleChange = (event) => {
    //event.preventDefault();
    let target = event.target;
    let value = target.type === "checkbox" ? target.checked : target.value;
    let name = target.name;

    setState({ ...state, [name]: value });

    if (formSubmitted) {
      validateFields();
    }
  };

  const onVerify = (recaptchaResponse) => {
    setRecaptchaToken(recaptchaResponse);
  };

  const sendContactForm = async () => {
    captcha.current.execute();
    setFormSubmitted(true);

    if (validateFields()) {
      let res = await fetch("/api/send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...state,
          responseToken: recaptchaToken,
          lang: lang,
        }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data && data.success) {
            logEvent("contact", "contact sent", "contact");
            setFormSuccess(true);
          } else if (data) {
            if (data.type && data.type === "invalid_token") {
              setMessages({
                ...messages,
                general:
                  "Er ging iets mis probeer het opnieuw. (recaptcha error)",
              });
            } else {
              setMessages({
                ...messages,
                general: "Er ging iets mis, probeer het opnieuw. ",
              });
            }
            setFormFailed(true);
          }
        })
        .catch(function (error) {
          setMessages({
            ...messages,
            general: error,
          });
        });
    }
  };

  const validateFields = () => {
    let isValid = true;
    let updatedMessages = messages;

    if (!state.GDPR) {
      isValid = false;
      updatedMessages = {
        ...updatedMessages,
        GDPR: "Dit veld is verplicht.",
      };
    } else {
      updatedMessages = { ...updatedMessages, GDPR: false };
    }

    if (!state.firstName) {
      isValid = false;
      updatedMessages = {
        ...updatedMessages,
        firstName: "Dit veld is verplicht.",
      };
    } else {
      updatedMessages = { ...updatedMessages, firstName: false };
    }

    if (!state.lastName) {
      isValid = false;
      updatedMessages = {
        ...updatedMessages,
        lastName: "Dit veld is verplicht.",
      };
    } else {
      updatedMessages = { ...updatedMessages, lastName: false };
    }

    if (!state.email) {
      isValid = false;
      updatedMessages = {
        ...updatedMessages,
        email: "Dit veld is verplicht.",
      };
    } else {
      updatedMessages = { ...updatedMessages, email: false };
    }

    if (!state.phone) {
      isValid = false;
      updatedMessages = {
        ...updatedMessages,
        phone: "Dit veld is verplicht.",
      };
    } else {
      updatedMessages = { ...updatedMessages, phone: false };
    }

    if (!state.street) {
      isValid = false;
      updatedMessages = {
        ...updatedMessages,
        street: "Dit veld is verplicht.",
      };
    } else {
      updatedMessages = { ...updatedMessages, street: false };
    }

    if (!state.city) {
      isValid = false;
      updatedMessages = {
        ...updatedMessages,
        city: "Dit veld is verplicht.",
      };
    } else {
      updatedMessages = { ...updatedMessages, city: false };
    }

    if (!state.message) {
      isValid = false;
      updatedMessages = {
        ...updatedMessages,
        message: "Dit veld is verplicht.",
      };
    } else {
      updatedMessages = { ...updatedMessages, message: false };
    }

    setMessages(updatedMessages);

    setFieldValidation(isValid);

    return isValid;
  };

  const scrollTo = () => {
    scroller.scrollTo("contactForm", {
      duration: 800,
      delay: 0,
      smooth: "easeInOutQuart",
    });
  };

  return (
    <Page
      title="MERLET | Contact"
      description="Kunnen we u ergens mee helpen? Aarzel niet om contact op te nemen met onze specialisten."
    >
      <Header />
      <ContentBox
        bg="gold"
        maxWidth="inherit"
        display="flex"
        pt="130px"
        sx={{ flexDirection: ["column", "row", "row"], flexWrap: "wrap" }}
      >
        <Box variant="contactBox" width={[1, 1 / 3, 1 / 3]}>
          <Heading as="h3">ADRES</Heading>
          <Text>{data.address}</Text>
        </Box>
        <Box variant="contactBox" width={[1, 1 / 3, 1 / 3]}>
          <Heading as="h3">TELEFOON</Heading>
          <Text>
            <Link href={`tel:${data.phone}`}>{data.phone}</Link>
          </Text>
        </Box>
        <Box variant="contactBox" width={[1, 1 / 3, 1 / 3]}>
          <Heading as="h3">E-MAIL</Heading>
          <Link href={`mailto:${data.email}`}>{data.email}</Link>
        </Box>
      </ContentBox>
      <ContentBox bg="duckEggBlue">
        <Box variant="contactBox">
          <Heading as="h3">OPENINGSUREN</Heading>
        </Box>
        <Box
          sx={{
            textAlign: "center",
            h1: { fontSize: 4, fontWeight: "normal", m: 0 },
            p: {
              fontSize: 2,
              mt: 2,
              mb: 0,
            },
          }}
        >
          {RichText.render(data.opening_hours)}
        </Box>
      </ContentBox>
      <ContentBox>
        <Box variant="contactForm">
          <Heading as="h3" textAlign="center">
            CONTACT
          </Heading>
          <Text
            textAlign="center"
            fontSize={(4, 6, 6)}
            maxWidth="500px"
            mx="auto"
            mt={3}
          >
            Nog vragen? Vul dan onderstaand formulier in.
          </Text>

          <Box
            textAlign={["left"]}
            py={[2, 6, 5]}
            pl={[0, 2, 5]}
            sx={{ zIndex: 7777 }}
          >
            <Box>
              <Box
                mb="3"
                display={["block", "flex", "flex"]}
                flexWrap="wrap"
                justifyContent="space-between"
              >
                <Box
                  flexBasis={["100%", "100%", "50%"]}
                  mt={[3, 2, 2]}
                  pr={[0, 0, 2]}
                >
                  <Label>Voornaam *</Label>
                  <Input
                    id="firstName"
                    name="firstName"
                    onChange={handleChange}
                    value={state.firstName}
                    type="text"
                    py={3}
                    sx={
                      messages && messages.firstName
                        ? { borderColor: "red" }
                        : {}
                    }
                  />
                  {messages && messages.firstName && (
                    <Text fontSize={0} sx={{ color: "red.900" }}>
                      {messages.firstName}
                    </Text>
                  )}
                </Box>
                <Box
                  flexBasis={["100%", "100%", "50%"]}
                  mt={[3, 2, 2]}
                  pl={[0, 0, 2]}
                >
                  <Label>Achternaam *</Label>
                  <Input
                    id="lastName"
                    name="lastName"
                    onChange={handleChange}
                    value={state.lastName}
                    type="text"
                    py={3}
                  />
                  {messages && messages.lastName && (
                    <Text fontSize={0} sx={{ color: "red.900" }}>
                      {messages.lastName}
                    </Text>
                  )}
                </Box>
              </Box>
              <Box
                mb="3"
                display={["block", "flex", "flex"]}
                flexWrap="wrap"
                justifyContent="space-between"
              >
                <Box
                  flexBasis={["100%", "100%", "50%"]}
                  mt={[3, 2, 2]}
                  pr={[0, 0, 2]}
                >
                  <Label>E-mail *</Label>
                  <Input
                    id="email"
                    name="email"
                    placeholder="email@voorbeeld.be"
                    onChange={handleChange}
                    value={state.email}
                    type="email"
                    py={3}
                  />
                  {messages && messages.email && (
                    <Text fontSize={0} sx={{ color: "red.900" }}>
                      {messages.email}
                    </Text>
                  )}
                </Box>
                <Box
                  flexBasis={["100%", "100%", "50%"]}
                  mt={[3, 2, 2]}
                  pl={[0, 0, 2]}
                >
                  <Label>Telefoon / Mobiel *</Label>
                  <Input
                    id="phone"
                    name="phone"
                    onChange={handleChange}
                    value={state.phone}
                    type="text"
                    py={3}
                  />
                  {messages && messages.phone && (
                    <Text fontSize={0} sx={{ color: "red.900" }}>
                      {messages.phone}
                    </Text>
                  )}
                </Box>
              </Box>
              <Box
                mb="3"
                display={["block", "flex", "flex"]}
                flexWrap="wrap"
                justifyContent="space-between"
              >
                <Box
                  flexBasis={["100%", "100%", "50%"]}
                  mt={[3, 2, 2]}
                  pr={[0, 0, 2]}
                >
                  <Label>Straat + Nr *</Label>
                  <Input
                    id="street"
                    name="street"
                    type="text"
                    onChange={handleChange}
                    value={state.street}
                    py={3}
                  />
                  {messages && messages.street && (
                    <Text fontSize={0} sx={{ color: "red.900" }}>
                      {messages.street}
                    </Text>
                  )}
                </Box>
                <Box
                  flexBasis={["100%", "100%", "50%"]}
                  mt={[3, 2, 2]}
                  pl={[0, 0, 2]}
                >
                  <Label>Gemeente *</Label>
                  <Input
                    id="city"
                    name="city"
                    onChange={handleChange}
                    value={state.city}
                    type="text"
                    py={3}
                  />
                  {messages && messages.city && (
                    <Text fontSize={0} sx={{ color: "red.900" }}>
                      {messages.city}
                    </Text>
                  )}
                </Box>
              </Box>
              <Box>
                <Label>Je bericht *</Label>
                <Textarea
                  rows="3"
                  id="message"
                  name="message"
                  onChange={handleChange}
                  value={state.message}
                  py={3}
                ></Textarea>
                {messages && messages.message && (
                  <Text fontSize={0} sx={{ color: "red.900" }}>
                    {messages.message}
                  </Text>
                )}
              </Box>
              <Box mt={4} textAlign="center">
                <Box
                  as="input"
                  id="GDPR"
                  name="GDPR"
                  type="checkbox"
                  checked={state.GDPR}
                  onChange={(e) => {
                    handleChange(e);
                  }}
                  display="inline"
                />
                <Text display="inline" ml={2}>
                  Ik ga akkoord met de verwerking van mijn gegevens volgens het{" "}
                  <Link
                    className="secondaryLink"
                    href="/privacybeleid"
                    target="_blank"
                  >
                    privacybeleid. *
                  </Link>
                </Text>
                {messages && messages.GDPR && (
                  <Text fontSize={0} mt={4} sx={{ color: "red.900" }}>
                    {messages.GDPR}
                  </Text>
                )}
              </Box>
              <Box textAlign="center">
                {formSubmitted && formSuccess ? (
                  <Box
                    mt={5}
                    fontSize={3}
                    sx={{ color: "green.900", "&:hover": { color: "black" } }}
                  >
                    <Text
                      display="inline"
                      sx={{
                        mr: 2,
                        "&:hover": { mr: 3 },
                        transition: "all 0.4s",
                      }}
                    >
                      {_t(
                        lang,
                        "button-bericht-verzonden",
                        "Bericht verzonden"
                      )}
                    </Text>
                    <FontAwesomeIcon icon={faCheck} />
                  </Box>
                ) : (
                  <>
                    <Reaptcha
                      ref={captcha}
                      sitekey="6Lc4594UAAAAAJWc8agdZChxVXKd1fcBnStmOVFT"
                      onVerify={onVerify}
                      size="invisible"
                    />
                    <Box
                      as="button"
                      mt={5}
                      fontSize={3}
                      sx={{
                        cursor: "pointer",
                        "&:hover": { color: "primary" },
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        sendContactForm();
                      }}
                    >
                      <Text display="inline">
                        {_t(
                          lang,
                          "button-bericht-verzenden",
                          "Bericht verzenden"
                        )}
                      </Text>
                      {!formSubmitted || !fieldValdation ? (
                        <></>
                      ) : (
                        <FontAwesomeIcon icon={faCircleNotch} spin />
                      )}
                    </Box>

                    {messages && messages.general && (
                      <Box mt={3}>
                        <Text fontSize={0} sx={{ color: "red.900" }}>
                          {messages.general}
                        </Text>
                      </Box>
                    )}
                  </>
                )}
              </Box>
              <Box mt="4" textAlign="center">
                <Text fontSize={0} sx={{ color: "black", opacity: 0.4 }}>
                  This site is protected by reCAPTCHA and the Google{" "}
                  <Link
                    variant="link.none"
                    sx={{ textDecoration: "underline" }}
                    href="https://policies.google.com/privacy"
                    target={"_blank"}
                  >
                    Privacy Policy
                  </Link>{" "}
                  and{" "}
                  <Link
                    variant="link.none"
                    sx={{ textDecoration: "underline" }}
                    href="https://policies.google.com/terms"
                    target={"_blank"}
                  >
                    Terms of Service
                  </Link>{" "}
                  apply.
                </Text>
              </Box>
            </Box>
          </Box>
        </Box>
      </ContentBox>
      <Footer />
    </Page>
  );
};

Contact.getInitialProps = async ({ ctx, req, query: { lang } }) => {
  let pageContent = {};
  const contact = await Prismic.client(apiEndpoint).getSingle("contact", {});

  return { pageContent, lang, doc: contact };
};

export default Contact;
